import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import { MatDatepicker, MatDatepickerInput } from '@angular/material/datepicker';
import { MatSelect } from '@angular/material/select';
import {debounceTime} from 'rxjs/operators';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent {
  @ViewChild('text', {static: false}) text: ElementRef;
  @ViewChild('date', {static: false}) date: MatDatepicker<any>;
  @ViewChild(MatDatepickerInput, {static: false}) dateInput: MatDatepickerInput<any>;
  @ViewChild('select', {static: false}) select: MatSelect;

  @Output() public filter: EventEmitter<any> = new EventEmitter<any>();
  @Input() public options: {
    name: string,
    value: string,
    type: 'text' | 'select' | 'date',
    data?: any | { value: any, name: string }[]
  }[];
  public inputEmitter: EventEmitter<{ optionValue: string, value: any, type: string }> = new EventEmitter<{ optionValue: string, value: any, type: string }>();
  @ViewChild('filterSelection', {static: true}) public filterSelection: MatSelect;

  constructor() {
    this.inputEmitter.pipe(debounceTime(500)).subscribe(i => {
      this.onChange(i.optionValue, i.value, i.type);
    });
  }

  onChange(optionValue, value, type) {
    if (optionValue && value !== null) {
      this.filter.emit({optionValue, value, type});
    }
  }

  public clearFilters() {
    this.filterSelection.value = undefined;
    this.resetValues();
    this.filter.emit({optionValue: null, value: null, type: null});
  }

  public onFilterSelectionChange() {
    this.resetValues();
    this.filter.emit({optionValue: null, value: null, type: null});
  }

  public resetValues() {
    if (this.text?.nativeElement) {
      this.text.nativeElement.value = null;
    }
    if (this.dateInput) {
      this.dateInput.value = null;
    }
  }
}
